
class PersistentStoreService {
  private cacheMap = new Map()

  set(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value))
    this.cacheMap.set(key, value)
  }
  get<T>(key: string): T | undefined {
    if (this.cacheMap.has(key)) {
      return this.cacheMap.get(key)
    }
    const json = localStorage.getItem(key)
    const value = json ? JSON.parse(json) : undefined
    if (value) {
      this.cacheMap.set(key, value)
    }
    return value
  }

  remove(key: string) {
    this.cacheMap.delete(key)
    localStorage.removeItem(key)
  }

  async clear() {
    this.cacheMap.clear()
    localStorage.clear()
  }
}

export default new PersistentStoreService()